








import Vue from 'vue';
import { Loading } from '@/components/ds';

export default Vue.extend({
  components: { Loading },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
});
